// import React from "react";

// const InvoiceModalbyMedicine = ({
//   invoiceData,
//   invoiceNumber,
//   patientName,
//   doctorName,
//   patientAddress,
//   sale_date,
//   onClose,
// }) => {
//   // Calculate the grand total
//   const grandTotal = invoiceData.reduce(
//     (acc, item) => acc + item.quantity * item.unit_price,
//     0
//   );
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   return (
//     <div className="ml-44 fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white rounded-lg p-6 w-[60%] max-h-[80vh] overflow-y-auto">
//         {/* Invoice Header */}
//         <div className="flex flex-row justify-between">
//           <div className="mb-6">
//             <h2 className="text-2xl font-bold">Invoice #{invoiceNumber}</h2>
//             <p className="text-md text-gray-700">Patient: {patientName}</p>
//             <p className="text-md text-gray-700">Address: {patientAddress}</p>
//             <p className="text-md text-gray-700">{doctorName}</p>
//           </div>
//           <div className="text-right">
//             <p className="text-md text-gray-700">
//               Date: {formatDate(sale_date)}
//             </p>
//           </div>
//         </div>

//         {/* Table Content */}
//         <table className="w-full border-collapse">
//           <thead>
//             <tr>
//               <th className="border px-4 py-2 text-left">Medicine Name</th>
//               <th className="border px-4 py-2 text-left">Quantity</th>
//               <th className="border px-4 py-2 text-left">Unit Price</th>
//               <th className="border px-4 py-2 text-left">Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoiceData.map((item, index) => (
//               <tr key={index}>
//                 <td className="border px-4 py-2">{item.medicine_name}</td>
//                 <td className="border px-4 py-2">{item.quantity}</td>
//                 <td className="border px-4 py-2">{item.unit_price}</td>
//                 <td className="border px-4 py-2">
//                   {item.quantity * item.unit_price}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Grand Total */}
//         <div className="mt-4 mr-24 flex justify-end">
//           <span className="font-bold text-xl">Grand Total: </span>
//           <span className="text-xl ml-2">{grandTotal}</span>
//         </div>

//         {/* Close Button */}
//         <div className="mt-6 text-center">
//           <button
//             className="bg-gray-100 hover:bg-gray-200 text-black px-4 py-1 rounded-md border-2"
//             onClick={onClose}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InvoiceModalbyMedicine;


import React from "react";

const InvoiceModalbyMedicine = ({
  invoiceData,
  invoiceNumber,
  patientName,
  doctorName,
  patientAddress,
  sale_date,
  onClose,
}) => {
  const grandTotal = invoiceData.reduce(
    (acc, item) => acc + item.quantity * item.unit_price,
    0
  );

  const formatCurrency = (amount) =>
    `Rs. ${(Number(amount) || 0).toFixed(2)}`;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  return (
    <>
      <div
        className="fixed inset-0 z-50   flex items-center justify-center"
        style={{ background: "rgba(10,37,64,0.45)", backdropFilter: "blur(3px)" }}
        
      >
        <div
          className="bg-white  mt-10 rounded-2xl shadow-2xl w-full flex flex-col"
          style={{ maxWidth: 620, maxHeight: "88vh", animation: "slideUp 0.25s ease" }}
        >
          {/* Header */}
          <div className="bg-gray-800 px-6 py-4 rounded-t-2xl flex items-center justify-between flex-shrink-0">
            <div>
              <h2 className="text-white text-[17px] font-[500] tracking-tight">
                Invoice Preview
              </h2>
              <p className="text-gray-400 text-[12px] mt-0.5">
                Invoice #{invoiceNumber}
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            >
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Scrollable Body */}
          <div className="overflow-y-auto flex-1 px-6 py-5">

            {/* Info Cards */}
            <div className="grid grid-cols-4 gap-3 mb-5">
              {[
                {
                  label: "Patient",
                  value: patientName || "N/A",
                  icon: (
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  ),
                },
                {
                  label: "Doctor",
                  value: doctorName || "N/A",
                  icon: (
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  ),
                },
                {
                  label: "Address",
                  value: patientAddress || "N/A",
                  icon: (
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  ),
                },
                {
                  label: "Sale Date",
                  value: formatDate(sale_date),
                  icon: (
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  ),
                },
              ].map(({ label, value, icon }) => (
                <div key={label} className="bg-gray-50 border border-gray-100 rounded-xl px-4 py-3">
                  <div className="flex items-center gap-2 text-gray-400 mb-1">
                    {icon}
                    <span className="text-[11px] uppercase tracking-wide font-[600]">{label}</span>
                  </div>
                  <p className="text-[13px] font-[500] text-gray-800 truncate">{value}</p>
                </div>
              ))}
            </div>

            {/* Items Table */}
            <div className="border border-gray-100 rounded-xl overflow-hidden mb-5">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-800 text-[11px] uppercase text-white">
                    <th className="py-2.5 px-4 text-left">Medicine Name</th>
                    <th className="py-2.5 px-4 text-center">Qty</th>
                    <th className="py-2.5 px-4 text-right">Unit Price</th>
                    <th className="py-2.5 px-4 text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceData.map((item, index) => (
                    <tr
                      key={index}
                      className="border-t border-gray-100 hover:bg-gray-50 text-[13px]"
                    >
                      <td className="py-3 px-4 font-[500] text-gray-800">
                        {item.medicine_name || "N/A"}
                      </td>
                      <td className="py-3 px-4 text-center text-gray-600">
                        {item.quantity}
                      </td>
                      <td className="py-3 px-4 text-right text-gray-600">
                        {formatCurrency(item.unit_price)}
                      </td>
                      <td className="py-3 px-4 text-right font-[500] text-gray-800">
                        {formatCurrency(item.quantity * item.unit_price)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Grand Total */}
            <div className="flex justify-end">
              <div className="bg-gray-800 text-white rounded-xl px-6 py-3 flex items-center gap-4">
                <span className="text-[12px] text-white uppercase tracking-wide">
                  Grand Total
                </span>
                <span className="text-[20px] font-[600]">
                  {formatCurrency(grandTotal)}
                </span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-100 px-6 py-4 flex items-center justify-end flex-shrink-0 rounded-b-2xl bg-white">
            <button
              onClick={onClose}
              className="flex items-center gap-2 border border-gray-200 text-gray-700 hover:bg-gray-50 text-[13px] font-[500] px-5 py-2 rounded-lg transition-colors"
            >
              ← Close
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default InvoiceModalbyMedicine;